import React, {useEffect, useRef, useState} from 'react';

import {
  View,
  Text,
  TouchableOpacity,
  StyleSheet,
  SafeAreaView,
  Dimensions,
  FlatList,
  NativeEventEmitter,
  NativeModules,
  BackHandler,
  Linking,
  ScrollView,
  Platform,
  Image,
} from 'react-native';
import {globalFontStyle, globalStyle} from '../../../assets';
import Header from '../../../commonComponents/Header';
import {DEPOSIT_VAL, DEPOSIT_VAL_INTERNATIONAL} from '../wallet.constant';
import {useForm} from 'react-hook-form';
import {
  globalConfigurableData,
  globalConst,
  GlobalScreens,
} from '../../../utils/globalConstant';
import {Network} from '../../../utils/network';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Colors from '../../../assets/Color/Colors';
import CommonModal from '../../../commonComponents/commonModal';
import CouponModal from '../childComponents/CouponModal';
import {
  trackMoengageEvent,
  conversionMethod,
  isMobile,
  getDepositAmountPlaceholder,
  getCurrencyIcon,
  delayString, openURL,
} from '../../../utils/commonMethods';
import {connect, useDispatch, useSelector} from 'react-redux';

import WebView from 'react-native-webview';
import Width from '../../../assets/Width';
import {getConversionData, setDepositGSTData} from '../redux/wallet.action';
import AddMoneyDetails from '../childComponents/AddMoneyDetails';
import DropDown from '../../../commonComponents/Forms/dropDown';
import {INDIA, REST_OF_WORLD} from '../../../utils/constants';
import {
  hideLoader,
  showLoader,
} from '../../../commonComponents/Loader/loader.actions';
import {
  tripleARecharge,
  fetchJuspayStatus,
  initJuspay,
  config,
} from '../childComponents/addMoneyUtils';
import DisclaimerConfig from '../../../commonComponents/DisclaimerConfig';
import RadioButton from '../../../commonComponents/RadioButton';
import {TEST_API} from '../../../utils/apiUrl';
import {international_redirect, paymentmodes_img, usdt_currency} from '../../../utils/images';
import FastImage from '../../../common/FastImage';
import {walletImport} from '../walletImports';
import {globalImport} from '../../../common/globalImports';
import OnMetaPaymentFlow from '../childComponents/OnMetaPaymentFlow';
import {useMetaHandling} from './useMetaHandling';
import {
  cashfreeRecharge,
  failureFunctionApp,
  failureFunctionWeb,
  successFunction,
} from '../childComponents/cashfree';
import {useFocusEffect} from '@react-navigation/native';
import TripleAWebView from '../childComponents/TripleAWebView';
import WalletAmountReview from './WalletAmountReview';
import WalletTxnStatus from '../childComponents/WalletTxnStatus';
import {REACT_APP_ENV} from '../../../../index';
import PayKasamaWallet from '../childComponents/PayKasamaWallet';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import PaymentSelection from '../childComponents/PaymentGatewaySelection';
import CouponBlk from '../../rewards/childComponents/couponBlk';
import CouponBottomSheet from '../../rewards/childComponents/couponBottomSheet';
import CouponSuccessScreen from './couponSuccesScreen';
import LinkQu from '../childComponents/LinkqU';
import LoginVerify from '../../Login/childComponents/LoginVerify';
import ChangeNumber from '../childComponents/ChangeNumber';
import magic from '../../../lib/magic';
import MagicBalance from '../childComponents/MagicBalance';
import {Button} from '../../../components/core/Button';
import {Input} from '../../../components/core/Input';
import {useToast} from '../../../components/core/Toast';
import Select from '../../../components/core/Select';
import {AlertDialog} from '../../../components/core/AlertDialog';
import {pincodeDirectory} from 'india-pincode-lookup';

const INDIAN_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal'
];

const RESTRICTED_STATES = [
  'ASSAM',
  'ODISHA',
  'ANDHRA PRADESH',
  'TELANGANA',
  'NAGALAND',
  'SIKKIM',
  'CHHATTISGARH',
  'CHATTISGARH'
];

const AddMoney = ({
  navigation,
  route,
  getConversionData,
  conversionData,
  rechargeAmountEvent,
}) => {
  const ref = useRef(null);
  const isMobileApp = !globalImport.isWeb;
  const {
    control,
    formState: {errors, isValid, isSubmitting},
    handleSubmit,
    setValue,
    watch,
  } = useForm({mode: 'onChange'});
  const rechargeAmountLocal = rechargeAmountEvent
    ? rechargeAmountEvent
    : route?.params?.rechargeAmount;

  const [enableReviewScreen, setEnableReviewScreen] = useState(false);
  const [showWalletSelection, setShowWalletSelection] = useState(
    isMobile() ? false : true,
  );
  const [couponList, setCouponList] = useState([]);
  const [enableStatusScreen, setEnableStatusScreen] = useState({
    paymentStatus: null,
  });
  const [showMobInputPopUp, setShowMobInputPopUp] = React.useState(false);
  const [mobileInputNum, setMobileInputNum] = React.useState();

  const {
    control: controlPromo,
    formState: {errors: errors2, isValid: isValid2},
    handleSubmit: handleSubmitPromo,
    watch: watchPromo,
    setValue: setValuePromo,
  } = useForm({
    mode: 'onChange',
  });
  const dispatch = useDispatch();

  const [onMetaPaymentConfig, setOnMetaPaymentConfig] = useState({
    upiOption: [],
    isShowPaymentOptions: false,
    orderIdDetails: null,
    startPolling: false,
  });

  const watchamount = watch('amount');
  const watchPromoCode = watchPromo('promoCode');

  const [conversionMessage, setConversationMessage] = React.useState('');
  const [promoMessage, setPromoMessage] = React.useState('');

  let userInfo = useSelector(({profile}) => profile?.profileData);
  const [paymentGateway, setPaymentGateway] = useState();
  const maxDepositLimit = paymentGateway?.depositLimit?.max || 10000;
  const minDepositLimit = paymentGateway?.depositLimit?.min || 1;

  const depositCurrencyIcon = paymentGateway?.currencyIcon;
  const depositCurrencyPlaceHolder = paymentGateway?.currencyPlaceholder;
  const isPaykasama = paymentGateway?.value.includes('paykassma');
  const isCurrencyIndia = paymentGateway?.currency === 'INR';
  const region = userInfo?.region_code ?? 'INDIA';
  const rechargeAmount = rechargeAmountLocal
    ? !isCurrencyIndia
      ? conversionData?.result?.value > 0
        ? (+rechargeAmountLocal / conversionData?.result?.value).toFixed(2)
        : null
      : rechargeAmountLocal
    : null;

  const isLinkq =
    paymentGateway?.value === 'linkqu-redirect' ||
    paymentGateway?.value === 'linkqu-qris' ||
    paymentGateway?.value === 'linkqu-ovopush' ||
    paymentGateway?.value === 'linkqu-cards';
  const isProfileComplete = userInfo?.isProfileComplete;

  const wallet_address =
    isLinkq && paymentGateway?.isMobileReq
      ? mobileInputNum
        ? mobileInputNum
        : paymentGateway?.mobile
      : '';

  let globalConfigData = useSelector(
    state => state.utilReducer.globalConfigData,
  );

  const networkTypes = paymentGateway?.fields?.[0]?.options ?? [];
  const enablePromoCode = paymentGateway?.enablePromoCode;

  const onDropdownSelect = value => {
    if (value) {
      setNetworkType(value);
    }
  };
  // const [usdtApprox, setApproxUSDT] = React.useState();

  useMetaHandling(onMetaPaymentConfig, setOnMetaPaymentConfig, watchamount);

  const usdtApprox = delayString(watchamount, null, conversionData);
  const [promoSuccessModal, setPromoSuccessModal] = useState(false);

  useEffect(() => {
    if (message?.status === 'success') {
      removePromo();
    }
  }, [watchamount]);

  const removePromo = () => {
    setValuePromo('promoCode', '');
    setPromoMessage('');
    setMessage({
      coupon: '',
      success: false,
      msg: '',
      applied_msg: '',
    });
  };

  useEffect(() => {
    setConversationMessage(conversionMethod(conversionData));
  }, [conversionData]);

  const [message, setMessage] = React.useState(null);
  const [htmlLink, setHtmlLink] = React.useState(null);

  let withDrawAmount = useRef(0);
  const [rechargeDetails, setRechargeDetails] = React.useState(null);
  const [showPayKasama, setIsShowPaykasama] = React.useState(null);
  const [IsShowLinkQ, setIsShowLinkQ] = React.useState(null);
  const [showCouponBottomList, setIsshowCouponBottomList] =
    React.useState(null);
  const [networkType, setNetworkType] = React.useState(
    networkTypes && networkTypes?.[0],
  );

  const getStateFromPincode = (pincode) => {
    try {
      const pincodeData = require('india-pincode-search');
      const result = pincodeData.search(pincode);
      if (result && Array.isArray(result) && result.length > 0) {
        return result[0].state.toUpperCase();
      }
      return null;
    } catch (err) {
      console.error('Error looking up pincode:', err);
      return null;
    }
  };

  const getCouponList = async () => {
    const list = await Network.getCouponList();
    if (list?.data?.success) {
      setCouponList(list?.data?.coupons);
    }
  };

  useEffect(() => {
    getCouponList();
  }, []);

  const { toast } = useToast();

  const confirmDepositClick = async data => {
    if (networkTypes?.length > 0 && !networkType) {
      toast({
        title: 'Please select a payment method',
        variant: 'destructive'
      });
      return;
    }
    setRechargeDetails(null);
    // let device_id;
    // if (isPaykasama) {
    //   device_id = await getSingularIdObj();
    // }
    let payload = {
      amount: REACT_APP_ENV === 'prod' ? parseInt(watchamount) : watchamount,
      pg: paymentGateway?.value,
      [paymentGateway?.fields?.[0]?.key]: networkType?.value,
      couponcode: promoMessage,
      device_id: userInfo?.userid,
      currency: isLinkq ? paymentGateway?.currency : null,
      mobile: mobileInputNum,
    };
    const res = await Network.createOrderWeb(payload, config, true);

    if (isLinkq) {
      return res;
    }

    if (
      isPaykasama &&
      (Platform.OS === 'web' ||
        globalConst.appVersion > (Platform.OS === 'android' ? 1085 : 1086))
    ) {
      setIsShowPaykasama(res?.data?.paykassma?.plugin_url);
    } else {
      if (Platform.OS === 'web') {
        setHtmlLink(res?.data?.triplea?.hosted_url);
        if (!isMobile()) {
          setEnableReviewScreen(false);
        }
      } else {
        var a = await tripleARecharge(res?.data?.triplea);
        setHtmlLink(a);
      }
    }
  };

  const confirmDepositClickGST = async res => {
    setRechargeDetails(null);

    !globalImport.isWeb && dispatch(showLoader());
    setTimeout(() => {
      cashfreeRecharge(res, res?.data?.order_amount, navigation);
    }, 250);
  };

  useEffect(() => {
    if (paymentGateway && paymentGateway?.currency !== 'INR') {
      getConversionData({
        currency: paymentGateway?.currency,
      });
    }
  }, [paymentGateway?.value]);

  const getPaymentGateway = async () => {
    if (!paymentGateway && userInfo && userInfo?.depositConfig) {
      if (userInfo?.depositConfig?.pg?.length > 1 && isMobile()) {
        let pg;
        if (globalImport.isWeb) {
          pg = window.sessionStorage.getItem('pg');
        } else {
          pg = await AsyncStorage.getItem('pg');
        }
        if (pg) {
          setPaymentGateway(JSON.parse(pg));
        } else {
          setShowWalletSelection(true);
        }
      } else {
        setPaymentGateway(userInfo?.depositConfig?.pg?.[0]);
        if (globalImport.isWeb) {
          window.localStorage.setItem(
            'pg',
            JSON.stringify(userInfo?.depositConfig?.pg?.[0]),
          );
        } else {
          await AsyncStorage.setItem(
            'pg',
            JSON.stringify(userInfo?.depositConfig?.pg?.[0]),
          );
        }
        // if (region !== INDIA) {
        //   getConversionData({
        //     currency: userInfo?.depositConfig?.pg?.[0]?.currency,
        //   });
        // }
      }
    }
  };

  useFocusEffect(
    React.useCallback(() => {
      getPaymentGateway();
    }, [userInfo]),
  );

  useEffect(() => {
    if (isProfileComplete === false && userInfo?.isDepositProfileMandatory) {
      const status = {
        isShow: true,
        status: false,
        msg: `Please complete your profile details first in order to deposit/withdraw funds`,
        // amount: amount,
        profileVerified: isProfileComplete,
        buttonText: 'Visit Profile Page',
      };
      if (!isMobile()) {
        setEnableStatusScreen({paymentStatus: status});
      } else {
        navigation.push('WalletStack', {
          screen: 'WalletStatus',
          params: {paymentStatus: status},
        });
      }
    }
  }, [isProfileComplete]);

  useEffect(() => {
    if (paymentGateway?.isMobileReq) {
      const isProfileComplete = userInfo?.isProfileComplete;
      if (isProfileComplete) {
        setShowMobInputPopUp(true);
      }
    }
  }, [paymentGateway]);

  useEffect(() => {
    if (region !== INDIA) {
      globalImport.isWeb &&
        window.addEventListener('message', onMessage, false);
    }
    return () => {
      if (paymentGateway?.value === 'triplea') {
        globalImport.isWeb &&
          window.removeEventListener('message', onMessage, false);
      }
      removePaymentGateway();
    };
  }, []);

  const removePaymentGateway = async () => {
    if (globalImport.isWeb) {
      window.sessionStorage.removeItem('pg');
    } else {
      await AsyncStorage.removeItem('pg');
    }
  };

  const handleQris = async () => {
    const res = await confirmDepositClick();

    if (res?.data) {
      switch (paymentGateway.value) {
        case 'linkqu-cards':
        case 'linkqu-redirect':
          if (globalImport.isWeb) {
            window.open(res.data[paymentGateway.value]?.redirectUrl, '_self');
          } else {
            navigation.navigate('LinkqCards', {
              rechargeDetails: {
                linkQUrl: res.data[paymentGateway.value]?.redirectUrl,
                callbackFun: d24Redirection,
              },
            });
            return;
          }
          // setIsShowLinkQ(res.data[paymentGateway.value]);
          break;
        case 'linkqu-qris':
          setIsShowLinkQ(res.data[paymentGateway.value]);
          break;
        case 'linkqu-ovopush':
          setIsShowLinkQ(res.data[paymentGateway.value]);
          break;
        default:
          console.log(res?.data?.[paymentGateway.value]);
      }
    }
  };

  const onPlaceOrderClick = async data => {
    // Check state restrictions based on pincode for Indian users
    if (region === INDIA && userInfo?.pincode) {
      const state = getStateFromPincode(userInfo.pincode);
      console.log('Derived state:', state);
      if (state && RESTRICTED_STATES.includes(state?.toUpperCase?.() || '')) {
        toast({
          title: 'Service Not Available',
          description: 'Due to regulatory requirements, our services are not available in your state.',
          variant: 'destructive',
        });
        return;
      }
    }

    // Continue with existing deposit flow
    if (networkTypes?.length > 0 && !networkType) {
      toast({
        title: 'Please select a payment method',
        variant: 'destructive'
      });
      return;
    }

    withDrawAmount.current = data?.amount;
    let res = '';
    if (paymentGateway?.value === 'direct24') {
      navigation.navigate('Direct24', {
        rechargeDetails: {
          amount: data?.amount,
          currency: paymentGateway?.currency,
          lang: 'EN',
          country: userInfo?.signup_country,
          payerEmail: userInfo?.email,
          payerFirstName: userInfo?.displayname,
          couponCode: promoMessage,
          callbackFun: d24Redirection,
        },
      });
      return;
    }
    if (isPaykasama || region !== 'INDIA') {
      if (
        (networkTypes?.length > 0 && networkType) ||
        networkTypes?.length === 0
      ) {
        if (isPaykasama) {
          confirmDepositClick();
          return;
        }
        if (isLinkq) {
          handleQris();
          return;
        }
        if (region !== 'INDIA') {
          const details = {
            withDrawAmount: data?.amount,
            convertedAmount: usdtApprox,
            gatewayFees: paymentGateway?.gatewayFees,
            networkType: networkType?.value,
          };
          if (!isMobile()) {
            setEnableReviewScreen(true);
          } else {
            navigation.navigate('WalletAmountReview', {
              rechargeDetails: details,
              isGSTScreenShow: paymentGateway?.isGSTScreenShow,
              confirmDepositClick: confirmDepositClick,
            });
            //setRechargeDetails(details);
          }
        }
      } else {
        Toast.show({
          type: 'error',
          text1: 'Please select a payment method',
          visibilityTime: 2000,
          position: 'bottom',
        });
      }
    } else {
      res = await Network.createOrderWeb(
        {
          amount: parseInt(data?.amount),
          couponcode: promoMessage,
          afUserId: globalImport.isWeb
            ? ('; ' + document.cookie).split(`; afUserId=`).pop().split(';')[0]
            : '',
        },
        config,
        true,
      );
      if (
        !isMobileApp &&
        res?.data?.onmeta?.redirect_actions?.deepLinks.length
      ) {
        setOnMetaPaymentConfig({
          ...onMetaPaymentConfig,
          upiOption: res?.data?.onmeta.redirect_actions?.deepLinks,
          isShowPaymentOptions: true,
          orderIdDetails: {
            onMetaOrderId: res?.data?.onmeta.orderId,
            orderId: res?.data?.orderId,
          },
        });
      } else {
        if (res?.data?.review?.show) {
          dispatch(setDepositGSTData(res));
          if (!isMobile()) {
            setEnableReviewScreen(true);
          } else {
            navigation.navigate('WalletAmountReview', {
              confirmDepositClick: confirmDepositClickGST,
            });
            //setRechargeDetails(details);
          }
        } else {
          if (res?.data?.payment_source === 'JP') {
            dispatch(showLoader());
            juspayRecharge(res?.data?.sdk_payload);
          } else {
            !globalImport.isWeb && dispatch(showLoader());
            cashfreeRecharge(res, res?.data?.amount, navigation);
          }
        }
      }
    }
  };

  const onMetaMoneyAdd = (redirectLink, isDesktop) => {
    dispatch(showLoader());

    !isDesktop && Linking.openURL(redirectLink);
    setOnMetaPaymentConfig({...onMetaPaymentConfig, startPolling: true});
  };

  React.useEffect(() => {
    setValue('amount', rechargeAmount, {
      shouldValidate: true,
      shouldDirty: true
    });
  }, [rechargeAmount]);

  React.useEffect(() => {
    if (paymentGateway?.value === 'cashfree') {
      if (isMobileApp) {
        // initJuspay();
        // BackHandler.addEventListener("hardwareBackPress", () => {
        //   return !HyperSdkReact.isNull() && HyperSdkReact.onBackPressed();
        // });

        walletImport.CFPaymentGatewayService.setCallback({
          onVerify(orderID) {
            successFunction(
              orderID,
              withDrawAmount.current,
              navigation,
              userInfo,
              {
                data: {
                  title: 'Added Successfully',
                  success: true,
                  message: 'Credits are added to your wallet',
                },
              },
            );
          },
          onError(error, orderID) {
            !globalImport.isWeb && dispatch(hideLoader());
            failureFunctionApp(error, withDrawAmount.current, navigation);
          },
        });
        return () => {
          walletImport.CFPaymentGatewayService.removeCallback();
          // BackHandler.removeEventListener("hardwareBackPress", () => null);
        };
      }
    }
  }, [paymentGateway]);

  const juspayRecharge = async res => {
    await AsyncStorage.setItem('order_id', res?.payload?.orderId);
    //HyperSdkReact.process(JSON.stringify(res));
  };

  function onMessage(data) {
    // alert(JSON.stringify(data));
    var event;
    if (globalImport.isWeb) {
      event = data?.data;
    } else {
      event = data?.nativeEvent?.data;
    }

    switch (event) {
      case 'triplea.paymentSuccess':
        var a = {
          isShow: true,
          status: true,
          amount: 0,
          msg: 'Your transaction is currently processing.',
          title: 'Payment Processing!',
          disclaimer:
            'Might take 15-30 mins for the transaction to get updated',
          isDeposit: true,
        };
        // trackAppsflyerEvent('recharge_success', {
        //   status: 'success',
        //   orderId: '',
        //   datetime: new Date(),
        //   method: '',
        //   userId: userInfo?.userid,
        // });
        // trackAppsflyerEvent("recharge_amount", {
        //   status: "success",
        //   orderId: "",
        //   datetime: new Date(),
        //   af_revenue: amount,
        //   af_currency: "INR",
        // });
        if (!isMobile()) {
          setHtmlLink(null);
          setEnableStatusScreen({paymentStatus: a});
        } else {
          navigation.pop();
          navigation.push('WalletStack', {
            screen: 'WalletStatus',
            params: {paymentStatus: a},
          });
        }

        break;
      case 'triplea.error' || 'triplea.badTransaction' || 'triplea.formExpired':
        var a = {
          isShow: true,
          status: false,
          amount: 0,
          msg: 'Your deposit is failed. Please try again',
          title: 'Payment Failed!',
          disclaimer: '',
          isDeposit: true,
        };
        if (!isMobile()) {
          setHtmlLink(null);
          setEnableStatusScreen({paymentStatus: a});
        } else {
          navigation.pop();
          navigation.push('WalletStack', {
            screen: 'WalletStatus',
            params: {paymentStatus: a},
          });
        }
        break;
    }
  }
  useEffect(() => {
    if (globalImport.isWeb) {
      if (!window.location.href.includes('WalletSuccess')) {
        var query = window.location.search.substring(1);
        if (query?.split('?').length > 1) {
          var splitArr = query?.split('?');
          query = splitArr[splitArr.length - 1];
        }
        const params = new URLSearchParams(query);
        const order_id = params.get('myorder');
        if (order_id) {
          const cashfreeRes = {
            orderId: order_id,
          };
          cashfreeAddPayment(cashfreeRes);
          //const a = Network.addPayment(cashfreeRes);
          //console.log(a);
        }
      } else {
        try {
          const pg = JSON.parse(localStorage.getItem('pg'));
          if (pg.value !== 'direct24') {
            paykasamaRedirection();
          }
        } catch (e) {}
      }
    }
  }, []);

  useEffect(() => {
    if (globalImport.isWeb) {
      setTimeout(() => {
        if (window.location.href.includes('d24Status')) {
          let query = window.location.search.substring(1);
          const params = new URLSearchParams(query);
          const status = decodeURIComponent(params.get('d24Status'));
          d24Redirection(status);
        }
      }, 0);
    }
  }, []);

  const d24Redirection = status => {
    if (!globalImport.isWeb) {
      navigation.pop();
    }
    let a;
    if (status === 'success') {
      a = {
        isShow: true,
        status: 'Success',
        title: 'Payment Processing',
        msg: 'It might take 15-30 minutes for the transaction to get reflected in your wallet.',
        isDeposit: true,
      };
    } else {
      a = {
        isShow: true,
        isDeposit: true,
        status: false,
        msg: 'Your deposit is failed. Please try again',
        title: 'Payment Failed!',
      };
    }
    if (!isMobile()) {
      setEnableStatusScreen({paymentStatus: a});
    } else {
      navigation.push('WalletStack', {
        screen: 'WalletStatus',
        params: {paymentStatus: a},
      });
    }
  };

  const paykasamaRedirection = () => {
    setIsShowPaykasama(null);
    var a = {
      isShow: true,
      status: 'Success',
      title: 'Payment Processing',
      msg: 'It might take 15-30 minutes for the transaction to get reflected in your wallet.',
      isDeposit: true,
    };
    if (!isMobile()) {
      setEnableStatusScreen({paymentStatus: a});
    } else {
      navigation.push('WalletStack', {
        screen: 'WalletStatus',
        params: {paymentStatus: a},
      });
    }
  };

  const cashfreeAddPayment = async cashfreeRes => {
    const res = await Network.addPayment(cashfreeRes, true);
    if (res?.status === 500 || res?.data?.status === 'failed') {
      failureFunctionWeb(cashfreeRes?.amt, navigation, setEnableStatusScreen);
    } else {
      successFunction(
        cashfreeRes.orderId,
        cashfreeRes?.amt,
        navigation,
        userInfo,
        res,
        setEnableStatusScreen,
      );
    }
  };

  const onAmountSelect = val => {
    trackMoengageEvent('Add Funds', {
      'Amount Added': val,
      ProfileName: userInfo?.displayname,
      email: userInfo?.email,
      userId: userInfo?.userid,
    });
    setValue('amount', val, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  const amountIsValid = watchamount && watchamount >= minDepositLimit && watchamount <= maxDepositLimit;

  const onSubmitPromoCode = data => {
    if (message?.status) {
      setValuePromo('promoCode', '');
      setPromoMessage('');
      setMessage({
        coupon: '',
        success: false,
        msg: '',
        applied_msg: '',
        isShowPopUp: false,
      });
    } else {
      onPromoApply(data?.promoCode);
    }
  };

  const onPromoApply = async (promo, isManualPromo) => {
    // First check if amount is valid
    const amount = watchamount;
    
    // Check if amount is within valid range
    if (!amount || amount < minDepositLimit || amount > maxDepositLimit) {
      setMessage({
        coupon: promo,
        status: 'failed',
        msg: `Please enter a valid amount between ${minDepositLimit} and ${maxDepositLimit}`,
        isManualError: true,
        divClass: {borderColor: Colors.red, borderWidth: 2},
      });
      return;
    }

    const inputObj = {
      couponcode: promo,
      amount: amount,
    };

    const res = await Network.verifyCouponCodeRecharge(inputObj, true);
    if (!res?.data?.success) {
      setPromoMessage('');

      setMessage({
        coupon: promo,
        status: 'failed',
        msg: res?.data?.msg,
        applied_msg: res?.data?.applied_msg,
        isShowPopUp: true,
        isManualError: res?.data?.msg,
        divClass: {borderColor: Colors.red, borderWidth: 2},
      });
      if (showCouponBottomList && !isManualPromo) {
        setIsshowCouponBottomList(null);
      }
    } else {
      if (showCouponBottomList) {
        setIsshowCouponBottomList(null);
      }
      setPromoMessage(promo);
      setPromoSuccessModal(true);
      setMessage({
        coupon: promo,
        status: 'success',
        msg: res?.data?.msg,
        applied_msg: res?.data?.applied_msg,
        isShowPopUp: true,
        divClass: {borderColor: Colors.green, borderWidth: 2},
      });
    }
  };

  const onPaidClick = () => {
    setIsShowLinkQ(null);
    let a;

    a = {
      isShow: true,
      status: 'Success',
      title: 'Payment Processing',
      msg: 'It might take 15-30 minutes for the transaction to get reflected in your wallet.',
      isDeposit: true,
    };

    if (!isMobile()) {
      setEnableStatusScreen({paymentStatus: a});
    } else {
      navigation.push('WalletStack', {
        screen: 'WalletStatus',
        params: {paymentStatus: a},
      });
    }
  };

  const moneyOptionArr =
    paymentGateway?.presets ||
    (region !== INDIA ? DEPOSIT_VAL_INTERNATIONAL : DEPOSIT_VAL);

  useEffect(() => {
    if (wallet_address) {
      setValue('walletAddress', wallet_address);
    }
  }, [wallet_address]);

  const WalletAddressComp = React.useCallback(() => {
    return (
      <View>
        <FormTextLabel
          labelStyles={{alignSelf: 'flex-start'}}
          label={'Details'}
        />
        <View style={[styles.inputDiv]}>
          <Input
            control={control}
            name="walletAddress"
            placeholder="eg: xgdyt"
            disabled={!!wallet_address}
            variant="outline"
            rules={{
              required: 'Please enter a valid wallet address',
            }}
          />
        </View>
      </View>
    );
  }, [wallet_address, control]);

  const [headerTitle, setHeaderTitle] = useState('Add Funds');

  const handleHeaderChange = (title) => {
    setHeaderTitle(title);
  };

  return (
    <SafeAreaView style={[globalStyle.pageContainer, {flexGrow: 1}]} ref={ref}>
      <ScrollView
        contentContainerStyle={{flexGrow: 1}}
        keyboardShouldPersistTaps="handled"
        nestedScrollEnabled={true}
        scrollEventThrottle={16}>
        {/* Only show header for mobile */}
        {isMobile() && (
          <Header
            isInternalPage={false}
            navigation={navigation}
            pageName={headerTitle}
            backGroundColor={globalConfigurableData?.headerColor}
            translate={true}
          />
        )}
        <CommonModal
          onModalCallBack={() => {}}
          showModal={isMobile() && showWalletSelection}
          customModalStyle={[globalStyle.modalView, {alignItems: 'stretch'}]}
          persistent={true}>
          <PaymentSelection
            pG={userInfo?.depositConfig?.pg}
            onClick={() => setShowWalletSelection(false)}
            setPaymentGateway={setPaymentGateway}
          />
        </CommonModal>
        {htmlLink ? (
          <TripleAWebView
            htmlLink={htmlLink}
            setHtmlLink={setHtmlLink}
            onMessage={onMessage}
            watchamount={withDrawAmount}
            navigation={navigation}
            setTxnStatus={setEnableStatusScreen}
          />
        ) : !enableReviewScreen && !enableStatusScreen?.paymentStatus ? (
          <>
            {!showWalletSelection ||
            isMobile() ||
            (!isMobile() && userInfo?.depositConfig?.pg?.length === 1) ? (
              <View style={{flex: 1}}>
                <View
                  style={{
                    paddingHorizontal: 16,
                    marginTop: region === 'INDIA' ? 15 : 0,
                  }}>
                  {/* {!isMobile() && userInfo?.depositConfig?.pg?.length > 1 && (
                  <PaymentSelection
                    pG={userInfo?.depositConfig?.pg}
                    onClick={() => setShowWalletSelection(false)}
                    setPaymentGateway={setPaymentGateway}
                  />
                )} */}
                  {
                    region === INDIA && 
                    <><FormTextLabel
                    labelStyles={[
                      globalFontStyle.appFontSmallText,
                      {color: globalConfigurableData.quaternaryTextColor1, marginBottom: 4},
                    ]}
                    label={ region !== INDIA ? 'Convert USDT to TradeX Credits' : 'Enter Amount '}
                    rest={{conversionMessage: conversionMessage}}
                    /></>
                  }
                  <View
                    style={{
                      flexDirection: 'row',
                      alignItems: 'center',
                      marginTop: 0,
                    }}>
                    {/* {region !== INDIA ? (
                      <View style={{position: 'absolute'}}>
                        <FastImage
                          style={{
                            height: 22,
                            width: 22,
                            textAlign: 'center',
                            marginRight: 4,

                            left: 6,
                          }}
                          source={{uri: TEST_API + depositCurrencyIcon}}
                        />
                      </View>
                    ) : null} */}
                    {region == 'INDIA' && 
                    <Input
                      control={control}
                      name="amount"
                      placeholder={depositCurrencyPlaceHolder}
                      numeric={true}
                      variant="default"
                      containerStyle={{marginBottom: 0}}
                      inputStyle={{flex: 1}}
                      fullWidth
                      prefix={region !== INDIA ? {uri: TEST_API + depositCurrencyIcon} : undefined}
                      rules={{
                        validate: value => {
                          if (!value || value === '') return true; // Don't show error if empty
                          const numValue = parseFloat(value);
                          if (isNaN(numValue)) return "Please enter a valid amount";
                          if (numValue < minDepositLimit) return `Min deposit Amount is ${minDepositLimit}`;
                          if (numValue > maxDepositLimit) return `Max Deposit Per Transaction is ${maxDepositLimit}`;
                          return true;
                        }
                      }}
                    />}
                    {region !== INDIA ? (
                      <Text
                        style={{
                          textAlign: 'center',
                          position: 'absolute',
                          right: 6,
                          color: globalConfigurableData.primaryBtnColor,
                          ...globalFontStyle.appFontSmallText,
                        }}>
                        {usdtApprox}
                      </Text>
                    ) : null}
                    
                  </View>

                  {
                    region == INDIA && <View
                      style={{
                        flexDirection: 'row',
                        marginTop: 20,
                      }}>
                      {moneyOptionArr.map((item, index) => {
                        return (
                          <TouchableOpacity
                            onPress={() => onAmountSelect(item)}
                            activeOpacity={0.8}
                            key={index}
                            style={[
                              styles.moneyTapContainer,
                              index === 3 ? {marginRight: 0} : null,
                            ]}>
                            <Text style={{
                                textAlign: 'center',
                                color: globalConfigurableData.primaryTextColor1,
                            }}>{item}</Text>
                          </TouchableOpacity>
                        );
                      })}
                    </View>
                  }
                  { region !== INDIA ? (
                      <View>
                        <MagicBalance
                          moneyOptionArr={moneyOptionArr}
                          conversionMessage={conversionMessage}
                          navigation={navigation}
                          onHeaderChange={handleHeaderChange}
                        />
                      </View>
                    ) : null }
                </View>
                {/* <CouponBlk /> */}
                {/* promocode */}
                {enablePromoCode && (
                  <>
                    {!(couponList?.length > 0) ? (
                      <View style={{paddingHorizontal: 16, paddingVertical: 15}}>
                        <View style={{
                          flexDirection: 'row',
                          alignItems: 'center',
                          backgroundColor: globalConfigurableData.cardBgColor,
                          borderRadius: 8,
                          borderWidth: 1,
                          overflow: 'hidden',
                          borderColor: message?.status === 'success' 
                            ? Colors.green 
                            : message?.status === 'failed' 
                              ? Colors.red 
                              : globalConfigurableData.borderColor,
                        }}>
                          <View style={{flex: 1}}>
                            <Input
                              control={controlPromo}
                              name="promoCode"
                              placeholder="Enter promo code"
                              disabled={!!promoMessage || !amountIsValid}
                              variant="outline"
                              containerStyle={{
                                marginBottom: 0,
                                backgroundColor: 'transparent',
                              }}
                              style={{
                                borderWidth: 0,
                              }}
                              inputStyle={{
                                borderWidth: 0,
                                backgroundColor: 'transparent',
                                height: 46,
                              }}
                              fullWidth
                            />
                          </View>
                          <View style={{
                            width: 1,
                            alignSelf: 'stretch',
                            backgroundColor: message?.status === 'success' 
                              ? Colors.green 
                              : message?.status === 'failed' 
                                ? Colors.red 
                                : globalConfigurableData.borderColor,
                          }} />
                          <TouchableOpacity
                            onPress={handleSubmitPromo(onSubmitPromoCode)}
                            disabled={!amountIsValid || !watchPromoCode}
                            style={{
                              height: 46,
                              paddingHorizontal: 20,
                              justifyContent: 'center',
                              alignItems: 'center',
                              backgroundColor: 'transparent',
                              opacity: amountIsValid && watchPromoCode ? 1 : 0.5,
                            }}>
                            <Text style={{
                              ...globalFontStyle.appFontSmallTextBold,
                              color: message?.status === 'success' 
                                ? Colors.green 
                                : message?.status === 'failed' 
                                  ? Colors.red 
                                  : !amountIsValid 
                                    ? Colors.grey 
                                    : globalConfigurableData.primaryTextColor1,
                            }}>
                              {message?.status ? 'Remove' : 'Apply'}
                            </Text>
                          </TouchableOpacity>
                        </View>
                        {message?.msg && (
                          <FormTextLabel
                            labelStyles={[
                              globalFontStyle.appFontSmallText,
                              {
                                color: message?.status === 'success' ? Colors.green : Colors.red,
                                marginTop: 4
                              },
                            ]}
                            label={message?.msg}
                          />
                        )}
                      </View>
                    ) : (
                      <View style={{paddingHorizontal: 16, marginTop: 15}}>
                        <CouponBlk
                          isOnDepositScreen={true}
                          isCouponResponse={message}
                          couponItem={couponList ? couponList[0] : null}
                          onApplyclick={onPromoApply}
                          onViewMoreClick={() => {
                            setMessage({
                              ...message,
                              isManualError: false,
                            });
                            setIsshowCouponBottomList(true);
                          }}
                          onCouponRemove={removePromo}
                        />
                      </View>
                    )}
                  </>
                )}

                {networkTypes?.length > 0 && region !== INDIA && false ? (
                  <View
                    style={{
                      paddingHorizontal: 16,
                      marginTop: 0,
                    }}>
                    <Text
                      style={{
                        marginTop: -10,
                        marginBottom: 20,
                        ...globalFontStyle.appFontHeading,
                        color: globalConfigurableData.primaryTextColor1,
                        backgroundColor: globalConfigurableData.globalThemeColor,
                      }}>
                      {paymentGateway?.fields?.[0]?.label}
                    </Text>
                    <View
                      style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'wrap',
                      }}>
                      {(networkTypes ?? []).map(item => {
                        const isSelected = item?.value === networkType?.value;
                        return (
                          <TouchableOpacity
                            style={[
                              styles.radioOuterBox,
                              isSelected ? {backgroundColor: globalConfigurableData.primaryTextColor1,} : {},
                              {
                                width: globalImport?.isWeb
                                  ? ref?.current?.offsetWidth / 2 - 20
                                  : Width.width / 2 - 20,
                              },
                            ]}
                            activeOpacity={0.8}
                            onPress={() => {
                              onDropdownSelect(item);
                            }}
                            key={item?.label}>
                            <Text
                              style={[
                                  globalFontStyle.appFontBody,
                                  isSelected
                                      ? {
                                          color:
                                          globalConfigurableData.alternateTextColor,
                                      }
                                      : {
                                          color:
                                          globalConfigurableData.primaryTextColor1,
                                      },
                              ]}>
                              {item?.label}
                            </Text>
                          </TouchableOpacity>
                        );
                      })}
                    </View>
                  </View>
                ) : null}
                {globalConfigData?.mobikwikOffer && (
                  <FastImage
                    source={{
                      uri: TEST_API + globalConfigData?.mobikwikOffer,
                    }}
                    style={{
                      height: 230,
                      width: globalImport?.isWeb
                        ? ref?.current?.offsetWidth - 30
                        : Width.width - 30,
                      alignSelf: 'center',
                    }}
                  />
                )}
                {/* {region !== 'INDIA' && (
                    <TouchableOpacity onPress={() => openURL('https://T.me/TradeX54321')}>
                      <FastImage
                          source={international_redirect()}
                          style={{
                            marginTop: 20,
                            marginBottom: 20,
                            height: 120,
                            width: globalImport?.isWeb
                                ? ref?.current?.offsetWidth - 30
                                : Width.width - 30,
                            alignSelf: 'center',
                          }}
                      />
                    </TouchableOpacity>
                )} */}
                {/*region !== REST_OF_WORLD ? (
              <View>
                <Text style={{ textAlign: "center" }}>
                  All major payment methods supported
                </Text>
                <FastImage
                  source={paymentmodes_img()}
                  style={{
                    height: 80,
                    width: Width.width - 30,
                    alignSelf: "center",
                  }}
                />
              </View>
                ) : null*/}
                {paymentGateway?.isMobileReq ? (
                  <View
                    style={{
                      paddingHorizontal: 16,
                      marginTop: 20,
                    }}>
                    <WalletAddressComp />
                  </View>
                ) : null}

                <View style={{flex: 1}} />
                {region == INDIA && <DisclaimerConfig
                  config={paymentGateway?.disclaimers}></DisclaimerConfig>}
                {region == INDIA && <View
                  style={[
                    globalStyle.bottomAbsBtnBar,
                    globalImport?.isWeb
                      ? {width: ref?.current?.offsetWidth}
                      : {width: Width.width},
                  ]}>
                  <Button
                    variant={isValid && !errors?.amount ? "primary" : "disabled"}
                    onPress={handleSubmit(onPlaceOrderClick)}
                    translate={true}
                    disabled={!isValid || errors?.amount}
                    style={{flex: 1, marginTop: 15}}
                  >
                    Proceed
                  </Button>
                </View>}
              </View>
            ) : (
              <>
                {!isMobile() && userInfo?.depositConfig?.pg?.length > 1 && (
                  <PaymentSelection
                    pG={userInfo?.depositConfig?.pg}
                    onClick={() => setShowWalletSelection(false)}
                    setPaymentGateway={setPaymentGateway}
                    isDeposit={true}
                  />
                )}
              </>
            )}
          </>
        ) : !enableStatusScreen?.paymentStatus ? (
          <WalletAmountReview
            isGSTScreenShow={paymentGateway?.isGSTScreenShow}
            rechargeDetails={{
              withDrawAmount: withDrawAmount.current,
              convertedAmount: usdtApprox,
              gatewayFees: paymentGateway?.gatewayFees,
              networkType: networkType,
            }}
            setEnableReviewScreen={setEnableReviewScreen}
            confirmDepositClick={
              userInfo?.region === 'INDIA'
                ? confirmDepositClickGST
                : confirmDepositClick
            }
          />
        ) : (
          <WalletTxnStatus
            paymentStatus1={enableStatusScreen?.paymentStatus}
            setStatus={setEnableStatusScreen}
            navigation={navigation}
          />
        )}
        <CommonModal
          onModalCallBack={() => {
            setRechargeDetails(null);
          }}
          customModalStyle={[globalStyle.modalView]}
          showModal={rechargeDetails !== null}>
          <AddMoneyDetails
            rechargeDetails={rechargeDetails}
            confirmDepositClick={confirmDepositClick}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            setPromoSuccessModal(false);
          }}
          persistent={true}
          customModalStyle={[globalStyle.modalStyleCenter]}
          showModal={promoSuccessModal}>
          <CouponSuccessScreen
            dataObj={message}
            onOkayClick={() => {
              setPromoSuccessModal(false);
            }}
          />
        </CommonModal>

        <CommonModal
          onModalCallBack={() => {
            setIsShowPaykasama(null);
          }}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
          ]}
          showModal={showPayKasama !== null}>
          <PayKasamaWallet
            paykasamaLink={showPayKasama}
            paykasamaRedirection={paykasamaRedirection}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            setIsshowCouponBottomList(null);
          }}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
          ]}
          showModal={showCouponBottomList !== null}>
          <CouponBottomSheet
            onApplyclick={onPromoApply}
            couponList={couponList}
            isError={message?.isManualError}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            setOnMetaPaymentConfig({
              upiOption: [],
              isShowPaymentOptions: false,
              orderIdDetails: null,
              startPolling: false,
            });
          }}
          customModalStyle={[globalStyle.modalView]}
          showModal={onMetaPaymentConfig?.isShowPaymentOptions !== false}>
          {onMetaPaymentConfig?.isShowPaymentOptions ? (
            <OnMetaPaymentFlow
              paymentOptionList={onMetaPaymentConfig?.upiOption}
              onMetaMoneyAdd={onMetaMoneyAdd}
            />
          ) : null}
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            setIsShowLinkQ(null);
          }}
          customModalStyle={[
            isMobile() ? globalStyle.modalView : globalStyle.modalStyleCenter,
          ]}
          showModal={IsShowLinkQ !== null}>
          <LinkQu
            isQrCode={IsShowLinkQ?.qrCodeImgUrl ? true : false}
            onPaidClick={onPaidClick}
            amt={watchamount + ' ' + paymentGateway?.currency}
            linqQData={IsShowLinkQ}
          />
        </CommonModal>
        <CommonModal
          onModalCallBack={() => {
            navigation.pop();
          }}
          showModal={showMobInputPopUp}
          customModalStyle={[
            isMobile()
              ? {...globalStyle.modalView, alignItems: 'stretch'}
              : globalStyle.modalStyleCenter,
          ]}
          persistent={true}>
          <>
            {!paymentGateway?.mobile ? (
              <LoginVerify
                isAddMoney={true}
                mobVerfiedCallback={val => {
                  if (val) {
                    setMobileInputNum(val);
                  }
                  setShowMobInputPopUp(false);
                }}
              />
            ) : (
              <ChangeNumber
                isAddMoney={true}
                mobVerfiedCallback={val => {
                  if (val) {
                    setMobileInputNum(val);
                  }
                  setShowMobInputPopUp(false);
                }}
                mob={paymentGateway?.mobile}
              />
            )}
          </>
        </CommonModal>
      </ScrollView>
    </SafeAreaView>
  );
};

const mapStateToProps = ({wallet}) => ({
  conversionData: wallet.conversionData,
});

const mapDispatchToProps = {
  getConversionData,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddMoney);

const styles = StyleSheet.create({
  moneyTapContainer: {
    paddingHorizontal: 15,
    paddingVertical: 8,
    borderWidth: 0.75,
    borderColor: globalConfigurableData.borderColor,
    backgroundColor: globalConfigurableData.cardBgColor,
    borderRadius: 8,
    flex: 1,
    marginRight: 14,
  },
  inputDiv: {
    flexDirection: 'row',
    marginBottom: 16,
    paddingLeft: 0,
    borderRadius: 8,
    alignItems: 'center',
    borderColor: globalConfigurableData.borderColor,
    borderWidth: 1,
  },
  radioOuterBox: {
    //flexDirection: "row",
    marginBottom: 16,
    //paddingHorizontal: 10,
    paddingVertical: 10,
    borderRadius: 5,
    alignItems: 'center',
    //flexWrap: "wrap",
    backgroundColor: globalConfigurableData.cardBgColor,
    borderColor: globalConfigurableData.borderColor,
    borderWidth: 0.75,
    //justifyContent: "space-between",
    //flex: 1,
    width: Width.width / 2 - 20,
  },
  modalStyle: {
    width: Dimensions.get('window').width - 100,
    borderRadius: 12,
    padding: 0,
  },
  errorText: {
    ...globalFontStyle.appFontSmallText,
    color: Colors.red,
    marginTop: 4,
    marginLeft: 2,
  },
});
